import { DATE_FORMAT } from 'model/constants/date';
import moment from 'moment';
import React from 'react';

export const getParamFromURL = (param) => {
  const regex = new RegExp(`[?&]${param}=([^&]+).*$`);
  const decodeHref = decodeURI(window.location.href);
  const val = decodeHref.match(regex);
  return val === null ? '' : val[1];
};

export const formatDate = (dateMoment, format) => {
  if (!dateMoment || (dateMoment && !moment.isMoment(dateMoment))) return null;
  return dateMoment.format(format || DATE_FORMAT);
};

export const formatISODate = (dateMoment) => {
  if (!dateMoment || (dateMoment && !moment.isMoment(dateMoment))) return null;
  return dateMoment.toISOString();
};

/**
 * input: "2020-03-27"
 * output: "27-03-2020"
 */
export const formatFixedDate = (dateString, seperator, replaceSeperator) => {
  let replaceSeperatorValue = replaceSeperator ? replaceSeperator : '/';
  let seperatorValue = seperator ? seperator : '-';
  if (!dateString) return;
  const res = dateString.split(seperatorValue);
  return `${res[2]}${replaceSeperatorValue}${res[1]}${replaceSeperatorValue}${res[0]}`;
};

export const formatSeperatordDate = (dateString, seperator, replaceSeperator) => {
  let replaceSeperatorValue = replaceSeperator ? replaceSeperator : '/';
  let seperatorValue = seperator ? seperator : '-';
  if (!dateString) return;
  return dateString.replace(seperatorValue, replaceSeperatorValue);
};

export const getShortBase64 = (base64) => {
  if (!base64) return '';
  return base64.split('base64,')[1];
};

export const formatNumber = (x) => {
  if (!x) return 0;
  return x.toLocaleString();
};

export const formatCurrency = (number, isShowTypeCurrency = true) => {
  if (!number) return isShowTypeCurrency ? `0đ` : 0;
  const numberFormated = number.toLocaleString('en-US');
  return isShowTypeCurrency ? `${numberFormated}đ` : numberFormated;
};

export const countYear = (commencementDate, coverageEndDate) => {
  if (!commencementDate || !coverageEndDate) return 0;
  const numberFormated = coverageEndDate.split('/')[2] - commencementDate.split('/')[2];
  return numberFormated;
};

export const getYear = (date) => {
  if (!date) return 0;
  const numberFormated = date.split('/')[2];
  return numberFormated;
};

export const cloneArr = (arr) => {
  try {
    if (!arr) return [];
    return JSON.parse(JSON.stringify(arr));
  } catch (error) {
    return [];
  }
};

export const checkMenuExists = (menuPath, menuObj) => {
  let flag = false;

  for (let item in menuObj) {
    const itemMenu = menuObj[item];
    if (itemMenu.menuPath === menuPath) {
      flag = true;
      break;
    } else if (itemMenu.children && itemMenu.children?.length > 0) {
      const isExists = itemMenu.children?.findIndex((menu) => menu.menuPath === menuPath);
      if (isExists !== -1) {
        flag = true;
        break;
      }
    }
  }
  return flag;
};

export const highlightPhoneNumber = (text) => {
  const regexPhoneOrEmail = new RegExp(
    /(\d{4}\s\d{4})|(\d{9,11})|(ePOS\d{6,15})|((([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))/,
    'gi'
  );
  const regexPhone = new RegExp(/(\d{9,11})/);

  const textConverted = text.replace(regexPhoneOrEmail, (str) => {
    return `\n${str}\n`;
  });

  const arrayText = textConverted.split('\n');
  return arrayText?.map((item, index) => {
    if (regexPhoneOrEmail.test(item)) {
      if (regexPhone.test(item)) {
        item = item.substring(0, 3) + '***' + item.substring(6, item.length);
        return <a key={index} className='text-0090F0 underline'>{` ${item} `}</a>;
      }
      return (
        <a key={index} href={`tel:${item}`} className='text-0090F0 underline'>{` ${item} `}</a>
      );
    }
    return <span key={index}>{item}</span>;
  });
};

export const secondToHms = (number) => {
  if (!number) return { h: 0, m: 0, s: 0 };

  try {
    number = Number(number);
    let h = Math.floor(number / 3600);
    let m = Math.floor((number % 3600) / 60);
    let s = Math.floor((number % 3600) % 60);
    return { h, m, s };
  } catch (error) {
    return { h: 0, m: 0, s: 0 };
  }
};

export const getClientIdentityDocType = (type) => {
  switch (type) {
    case '0':
      return 'Khác';
    case '1':
      return 'CCCD';
    case '3':
      return 'Passport';
    case '4':
      return 'Giấy khai sinh';
    case '7':
      return 'CMND';
    default:
      return '';
  }
};

export const getGenderType = (type) => {
  switch (type) {
    case 'MALE':
      return 'Nam';
    case 'FEM':
      return 'Nữ';

    default:
      return '';
  }
};

export function capitalize(word) {
  const lower = word.toLowerCase();
  return word.charAt(0).toUpperCase() + lower.slice(1);
}

export const capitalizedCase = (word) => {
  if (!word) return '';

  return word
    .split(' ')
    .map((item) => capitalize(item))
    .join(' ')
    .replace(/\s\s+/g, ' ');
};

export const removeAlotString = (string) => {
  try {
    if (!string) return '';
    return string.replace(/\s\s+/g, ' ');
  } catch (error) {
    return '';
  }
};

export const normalizeString = (string) => {
  try {
    if (!string) return '';
    return string.trim().replace(/\s\s+/g, ' ');
  } catch (error) {
    return '';
  }
};

export const removeAccent = (string) => {
  try {
    if (!string) return '';
    return string
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd')
      .replace(/Đ/g, 'D');
  } catch (error) {
    return '';
  }
};

export const getClientIdnumberAndDate = (
  clientIdnumber,
  clientDateOfIssue,
  clientIssuingAuthority
) => {
  let text = '';
  if (clientIdnumber && clientDateOfIssue) {
    text += `${clientIdnumber} cấp ngày ${formatFixedDate(clientDateOfIssue)}`;
    if (clientIssuingAuthority) {
      text += ` tại ${clientIssuingAuthority}`;
    }
  } else {
    text = clientIdnumber;
  }
  return text;
};

export const getBankAccAndName = (bankAccount, bankName) => {
  let text = '';
  if (bankAccount) {
    text += `${bankAccount} `;
    if (bankName) {
      text += ` tại ${bankName}`;
    }
  } else {
    text = bankAccount;
  }
  return text;
};
export const getDateFromString = (string) => {
  // input : 20221205
  // output: 2022 , 12, 05
  const year = string.substring(0, 4);
  const month = string.substring(4, 6);
  const day = string.substring(6, 8);
  return { year, month, day };
};

const removeLocalStorage = () => {
  // const arrRemove = ['eposMenus', 'listAccountUser'];
  // for (let key in localStorage) {
  //   if (arrRemove.includes(key)) {
  //     localStorage.removeItem(key);
  //   }
  // }
  localStorage.clear();
};

export const formatTimeString = (dateISO) => {
  const dateConverted = new Date(dateISO);
  let hours = dateConverted.getHours();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  const minutes = `0${dateConverted.getMinutes()}`.slice(-2);
  const seconds = `0${dateConverted.getSeconds()}`.slice(-2);
  const date = `0${dateConverted.getDate()}`.slice(-2);
  const month = `0${dateConverted.getMonth() + 1}`.slice(-2);
  const year = dateConverted.getFullYear();
  const currentDay = dateConverted.getDay();
  const convertDay = (currentDay) => {
    switch (currentDay) {
      case 0:
        currentDay = 'Chủ nhật';
        break;
      case 1:
        currentDay = 'Thứ hai';
        break;
      case 2:
        currentDay = 'Thứ ba';
        break;
      case 3:
        currentDay = 'Thứ tư';
        break;
      case 4:
        currentDay = 'Thứ năm';
        break;
      case 5:
        currentDay = 'Thứ sáu';
        break;
      case 6:
        currentDay = 'Thứ bảy';
        break;
      default:
        return;
    }
    return currentDay;
  };
  const day = convertDay(currentDay);
  return { year, month, date, day, hours, ampm, minutes, seconds };
};
export const isJson = (input) => {
  try {
    JSON.parse(input);
  } catch (error) {
    return false;
  }
  return true;
};
const Utils = {
  removeLocalStorage,
};

export const format_curency = (price) => {
  return price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
};

export const convertObjToArr = (obj) => {
  const transform = [];
  try {
    Object.keys(obj).map(function (key, index) {
      const item = obj[key];
      transform.push(item);
    });
  } catch (error) {
    return [];
  }
  return transform;
};

export default Utils;
